import { Directive, ElementRef, Input, NgZone, HostListener, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[body_size]'
})
export class BodySizeDirective implements AfterViewInit {

  constructor(private el: ElementRef, private ngZone: NgZone) {
    this.resizePageContent();
  }

  @HostListener('window:resize', ['$event']) onResize($event) {
    //ngZone.run will help to run change detection
    this.ngZone.run(() => {
      this.resizePageContent();
    });
  }

  /* Resize #page-content to fill empty space if exists */
  public resizePageContent(): void {
    var windowH = $(window).height();
    var header = $(this.el.nativeElement).find("header");
    var footer = $(this.el.nativeElement).find("#page-content + footer");
    var page = $(this.el.nativeElement).find("#page-container");
    var pageContent = $(this.el.nativeElement).find("#page-content");
    var sidebar = $(this.el.nativeElement).find("#sidebar");
    var sidebarAlt = $(this.el.nativeElement).find("#sidebar-alt");
    var sidebarH = sidebar.outerHeight();
    var sidebarAltH = sidebarAlt.outerHeight();
    var headerH = header.outerHeight();
    var footerH = footer.outerHeight();

    // If we have a fixed sidebar/header layout or each sidebars’ height < window height
    if (header.hasClass('navbar-fixed-top') || header.hasClass('navbar-fixed-bottom') || ((sidebarH < windowH) && (sidebarAltH < windowH))) {
      if (page.hasClass('footer-fixed')) { // if footer is fixed don't remove its height
        pageContent.css('min-height', windowH - headerH + 'px');
      } else { // else if footer is static, remove its height
        pageContent.css('min-height', windowH - (headerH + footerH) + 'px');
      }
    } else { // In any other case set #page-content height the same as biggest sidebar's height
      if (page.hasClass('footer-fixed')) { // if footer is fixed don't remove its height
        pageContent.css('min-height', ((sidebarH > sidebarAltH) ? sidebarH : sidebarAltH) - headerH + 'px');
      } else { // else if footer is static, remove its height
        pageContent.css('min-height', ((sidebarH > sidebarAltH) ? sidebarH : sidebarAltH) - (headerH + footerH) + 'px');
      }
    }
  };

  ngAfterViewInit() {
    this.resizePageContent();
  }

}
